/**
 * DOCK-01: the bottom-right corner is shared real estate — Ask Pegasus and
 * Team Chat both live there. This tiny store lets each dock know when the
 * other is open so buttons/panels never stack on top of each other.
 */
import { useSyncExternalStore } from "react";

type DockState = { aiOpen: boolean; chatOpen: boolean };
let state: DockState = { aiOpen: false, chatOpen: false };
const listeners = new Set<() => void>();

function set(patch: Partial<DockState>) {
  state = { ...state, ...patch };
  listeners.forEach((l) => l());
}
export const setAiOpen = (v: boolean) => set({ aiOpen: v });
export const setChatOpen = (v: boolean) => set({ chatOpen: v });

export function useDockState(): DockState {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => state,
  );
}
